import styled from 'styled-components'

import { deterministicThemeColour } from '@/utils/getColour'
import { getOptimisticInitials } from '@/utils/getInitials'

type AvatarProps = {
  bordered?: boolean
  size?: number
  fontSize?: string
}

const AvatarWrapper = styled.span<AvatarProps>`
  ${({ theme }) => theme.font.caption01}
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  padding-top: 1px; // seems to center better??
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: ${({ fontSize }) => fontSize};
  flex-shrink: 0;

  ${({ bordered, theme }) =>
    bordered && `border: 1px solid ${theme.colour.secondary._50};`}
`

type Props = {
  size?: number
  bordered?: boolean
  name: string
  forceColour?: string
  fontSize?: string
}

export const Avatar: React.FC<Props> = ({
  size = 24,
  bordered,
  name,
  forceColour,
  fontSize = '10px',
}) => {
  const background = forceColour ?? deterministicThemeColour(name)

  return (
    <AvatarWrapper
      size={size}
      bordered={bordered}
      fontSize={fontSize}
      style={{ background }}
    >
      {getOptimisticInitials(name)}
    </AvatarWrapper>
  )
}
